import React from "react"
import { graphql, Link } from "gatsby"

import { ClientOnly, Layout } from "../components/common"
import { MetaData } from "../components/common/meta"
import List from "../components/idealline/List"
import FirebaseProvider from "../components/idealline/Firebase"
import { BrowserRouter } from "react-router-dom"

const RacingLines = ({ location }) => {
    const title = "Racing Line Editor - Perfect Cornering Techniques"

    return (
        <>
            <MetaData
                location={location}
                title={title}
                description="Draw your racing line and perfect your cornering techniques."
                image="/images/blog/2025/07/3d-corner-navigation.jpg"
            />
            <Layout title={title} image="/images/blog/2025/07/3d-corner-navigation.jpg">
                <section className="post-full-content">
                    <p>
                        Mastering the racing line is one of the first tasks I am
                        doing to work on my lap times. Before I go to a
                        racetrack, I will draw my line onto the map and
                        prioritize the corners which I would like to work on
                        first.
                    </p>
                    <aside className="racing-line-award" aria-labelledby="racing-line-award-title">
                        <img
                            src="/images/google-maps-platform-awards-2025.png"
                            alt="Google Maps Platform Awards"
                            width="790"
                            height="156"
                        />
                        <div>
                            <p className="racing-line-award__eyebrow">Recognition · 2025</p>
                            <h2 id="racing-line-award-title">Google Maps Platform Awards 2025</h2>
                            <p>
                                Open Racer&apos;s Racing Line Editor was recognized for helping motorsport
                                enthusiasts and race coaches plan racing lines using Google Maps satellite imagery
                                before heading to the track.
                            </p>
                        </div>
                    </aside>
                    <h1>How to draw your racing line</h1>

                    <p>
                        I am focusing on the fastest corners first and then
                        looking at the corners leading to a straightaway.
                    </p>

                    <ol>
                        <li>
                            The geometrical line is usually the best for fast
                            corners connecting straightaways
                        </li>
                        <li>
                            Late turn in and late apex for corners leading to a
                            straightaway
                        </li>
                        <li>
                            In a set of curves focus on the last corner leading
                            to a straightaway. My goal is to be as early as
                            possible on the throttle, apex late and maximize my
                            corner exit speed
                        </li>
                    </ol>

                    <p>
                        I think that satellite images of outdoor tracks are a
                        great way to analyse the track and draw racing lines.
                    </p>

                    <div id="latest-lines" className="h-0 scroll-mt-24" />
                    <ClientOnly>
                        <BrowserRouter>
                            <FirebaseProvider>
                                <h1 className="mt-12">Latest Racing Lines</h1>
                                <List
                                    wrapperClass="post-feed lines !grid !grid-cols-1 sm:!grid-cols-2 lg:!grid-cols-3 gap-6"
                                    infiniteScroll
                                    limit={12}
                                />
                            </FirebaseProvider>
                        </BrowserRouter>
                    </ClientOnly>
                </section>
            </Layout>
        </>
    )
}
export default RacingLines
